import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";
import { Session } from "../../models/Session";
import ModifVJsfInput from "@/shared/components/ModifVJsfInput/ModifVJsfInput.vue";
import { FormsService } from "../../../Forms/services/FormService";
import DocumentViewer from "@/shared/components/DocumentViewer/DocumentViewer.vue";
import MedicalOrderDetail from "../../../MedicalOrder/components/MedicalOrderDetail/MedicalOrderDetail.vue";
import { MedicalOrderService } from "@/modules/MedicalOrder/services/MedicalOrderService";
import { FormSchema } from "@/shared/models/FormSchema";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { ERROR_FORM } from "../../constants/ProfileConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  SESSIONS_MESSAGES,
  SESSIONS_STATES,
  SESSION_CONSTANTS
} from "@/modules/Sessions/constants/SessionsConstants";
import { SessionService } from "../../../Sessions/services/SessionService";
import { Http } from "@status/codes";
import { SessionIntelliticks } from "@/modules/WebViews/GroupTypeService/models/SessionIntelliticks";
import { SESSION_VISUALIZATION_CONSTANTS } from "./constants/SessionVisualizationConstants";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { FORMS_ACCESS } from "@/modules/Forms/constants/FormsConstants";
import { MedicalOrderPreviewEventTimelineModel } from "@/modules/MedicalOrder/models/MedicalOrderPreviewEventTimelineModel";

Vue.use(Vuetify);

@Component({
  name: "SessionVisualizationProgress",
  components: { ModifVJsfInput, DocumentViewer, MedicalOrderDetail }
})
export default class SessionVisualizationProgress extends Vue {
  @Inject() formsService!: FormsService;
  @Inject() sessionService!: SessionService;
  @Inject() medicalOrderService!: MedicalOrderService;

  @Prop() session!: Session;

  SESSIONS_STATES = SESSIONS_STATES;
  showModalForm = false;
  showModaViewFile = false;
  schema: FormSchema = {
    type: "object",
    allOf: []
  };
  multimediaPath = "";
  fileName = "";
  valuesForm: any = {};
  formName = "";
  secondaryButtonClass = STYLE_CLASSES.SECONDARY_BTN;
  SESSION_VISUALIZATION_CONSTANTS = SESSION_VISUALIZATION_CONSTANTS;
  medicalOrder!: MedicalOrderPreviewEventTimelineModel;
  showModalMedicalOrder = false;
  cupsId = "";

  async showForm(form: { name: string; id: string; formTemplateId: string }) {
    try {
      const response = await this.formsService.formServiceInformation({
        formTemplateId: form.formTemplateId,
        formId: form.id,
        loadData: true
      });

      this.schema = this.readOnly(response.data?.schemaData?.schema!);
      this.valuesForm = response.data?.form.fields;
      this.formName = response.data?.formTemplate.name!;
      this.showModalForm = true;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${FORMS_ACCESS.GET}`
          : ERROR_FORM;

      Snackbar.popError(errorMessage);
    }
  }

  showFile(file: { name: string; url: string }) {
    this.showModaViewFile = true;
    this.multimediaPath = file.url;
    this.fileName = file.name;
  }

  closePreview() {
    this.showModaViewFile = false;
  }

  closeFormModal() {
    this.showModalForm = false;
  }

  async restartSession(session: Session) {
    try {
      const sessionToUpdate: SessionIntelliticks = {
        state: SESSIONS_STATES.ASIGNED,
        serviceId: session.service,
        sessionId: session.id!,
        groupId: session.group,
        sessionTemplateId: session.sessionTemplate
      };
      const response = await this.sessionService.updateSession(
        session.user,
        sessionToUpdate
      );
      if (response.code === Http.Ok) {
        this.$emit(
          SESSION_CONSTANTS.RESTART_SESSION,
          sessionToUpdate.sessionId
        );
      }
    } catch (error) {
      Snackbar.popError(SESSIONS_MESSAGES.SESSION_ERROR);
    }
  }

  readOnly(schema: FormSchema) {
    schema.allOf.forEach(item => {
      Object.keys(item.properties).forEach(element => {
        const type = item.properties[element]["x-display"] || "";
        if (!["string", "textarea"].includes(type)) {
          item.properties[element]["x-options"] = { disableAll: true };
        }
      });
    });
    return schema;
  }

  async medicalOrderOperations(session: Session) {
    if (session.medicalOrder) {
      const response = await this.medicalOrderService.getMedicalOrderById(
        session.medicalOrder
      );

      if (response.code == Http.Found) {
        this.medicalOrder = response.data as MedicalOrderPreviewEventTimelineModel;
        this.showModalMedicalOrder = true;
      }
      this.cupsId = this.medicalOrder.cupsPriceLevel.id ?? "";
    }
  }

  hideMedicalOrderModal() {
    this.showModalMedicalOrder = false;
  }
}
